/** Word-level IPA overrides for German. */
export const de: Record<string, string> = {
  abendsonnenschein: '/ˈaːbəntˌzɔnənʃaɪ̯n/',
  // Foreign city names in German texts
  Aires: '/ˈaɪ̯ʁɛs/',
  andrer: '/ˈandʁɐ/',
  balde: '/ˈbaldə/',
  bewußtsein: '/bəˈvʊstˌzaɪ̯n/',
  blütenschimmer: '/ˈblyːtənˌʃɪmɐ/',
  brahmanensohn: '/ˈbʁaːmaːnənˌzoːn/',
  Buenos: '/ˈbueːnɔs/',
  'c\u2019est': '/sɛ/', // French in Mann's Buddenbrooks
  chère: '/ʃɛːʁ/', // French in Mann's Buddenbrooks
  daß: '/das/',
  'davos-platz': '/ˈdaːvɔsˌplats/', // Swiss resort area
  demoiselle: '/dəmwaˈzɛl/', // French in Mann's Buddenbrooks
  düwel: '/ˈdyːvəl/', // Low German: devil
  faßt: '/fast/',
  feuertrunken: '/ˈfɔɪ̯ɐˌtʁʊŋkən/',
  flußufers: '/ˈflʊsˌʔuːfɐs/',
  frühlingsnachmittag: '/ˈfʁyːlɪŋsˌnaːxmɪtaːk/',
  gefahrdrohende: '/ɡəˈfaːɐ̯ˌdʁoːəndə/',
  geküßt: '/ɡəˈkʏst/',
  götterfunken: '/ˈɡœtɐˌfʊŋkən/',
  govinda: '/ɡoˈvɪnda/', // Sanskrit name
  graubündischen: '/ɡʁaʊ̯ˈbʏndɪʃən/',
  guizot: '/ɡiˈzoː/', // French name
  hätt: '/hɛt/', // contraction of hätte
  'ich\u2019s': '/ɪçs/',
  küßnacht: '/ˈkʏsnaxt/',
  macheath: '/məˈkiːθ/', // English name
  metternich: '/ˈmɛtɐnɪç/',
  müßt: '/mʏst/',
  mußte: '/ˈmʊstə/',
  New: '/njuː/',
  ook: '/oːk/', // Low German: also
  'prinz-regentenstraße': '/ˈpʁɪntsʁeˌɡɛntənˌʃtʁaːsə/',
  question: '/kɛsˈtjɔ̃/', // French in Mann's Buddenbrooks
  salwaldes: '/ˈzalˌvaldəs/', // Sal forest
  samsa: '/ˈzamza/', // Kafka character
  schriee: '/ˈʃʁiːə/',
  siddhartha: '/zɪˈdaːʁta/',
  sternklar: '/ˈʃtɛʁnklaːɐ̯/',

  très: '/tʁɛ/', // French in Mann's Buddenbrooks
  verliess: '/fɛɐ̯ˈliːs/',
  York: '/jɔʁk/',
  zarathustra: '/tsaʁaˈtʊstʁa/',
};
